import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next, useTranslation as useTranslationOrg } from 'react-i18next';
import { fallbackLanguage } from './constants';
import { getOptions } from './settings';

i18next
  .use(initReactI18next)
  .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    ...getOptions(),
    lng: fallbackLanguage,
    react: {
      useSuspense: false,
    },
  });

export function useTranslation(ns: string | string[] = 'common', options: Record<string, unknown> = {}) {
  return useTranslationOrg(ns, options);
}

export default i18next;
